import BeatboxShare from './BeatboxShare';

export default BeatboxShare;
